"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRO_SCAN_HELPER_LABELS = exports.PRO_INPUT_HELPER_LABELS = exports.CLIENT_NAMES = exports.PRO_VALIDATION_ERROR_TYPES = void 0;
const PRO_VALIDATION_ERROR_TYPES = {
    REQUIRED: "required",
    INVALID_PRO_NUMBER: "invalidProNumber",
    PRO_NUMBER_MIN: "proNumberMin",
    PRO_NUMBER_MAX: "proNumberMax",
    PRO_NUMBER_LENGTH_MISMATCH: "proNumberLengthMismatch",
    INVALID_CHECK_DIGIT: "invalidCheckDigit",
    DUPLICATE_NUMBER: "duplicateNumber",
    TERMINAL_MISMATCH: "terminalMismatch",
};
exports.PRO_VALIDATION_ERROR_TYPES = PRO_VALIDATION_ERROR_TYPES;
const CLIENT_NAMES = {
    SAIA: "SAIA",
    ESTES: "ESTES",
    SEFL: "SEFL",
    TSTCF: "TSTCF",
    TFRC: "TFRC",
    DEFAULT: "DEFAULT",
};
exports.CLIENT_NAMES = CLIENT_NAMES;
const PRO_INPUT_HELPER_LABELS = {
    SEFL: "Enter a pro number",
    DEFAULT: "Enter a pro number without check digit",
};
exports.PRO_INPUT_HELPER_LABELS = PRO_INPUT_HELPER_LABELS;
// partial-pro number without checkDigit & full- pro number with checkDigit
const PRO_SCAN_HELPER_LABELS = {
    SEFL: "scanHelperTextFullPro",
    DEFAULT: "scanHelperTextPartialPro",
};
exports.PRO_SCAN_HELPER_LABELS = PRO_SCAN_HELPER_LABELS;
